import React from 'react';
import { Card } from 'antd';
import AdvertForm from '../../AdvertForm/AdvertForm.component';
import { AdvertEntity, AttachmentProps } from '../../../../domain';

export interface ContentStepProps {
  advertModel: AdvertEntity;
  isLoading: boolean;
  isSubmitting: boolean;
  onTitleChange: (title: string) => void;
  onDescriptionChange: (description: string) => void;
  onUploadFile: ({ file, onSuccess }: { file: File; onSuccess: () => void }) => void;
  onRemoveAttachment: (attachment: AttachmentProps) => void;
  onReorderAttachments: (newOrder: AttachmentProps[]) => void;
}

const ContentStep: React.FC<ContentStepProps> = ({
  advertModel,
  isLoading,
  isSubmitting,
  onTitleChange,
  onDescriptionChange,
  onUploadFile,
  onRemoveAttachment,
  onReorderAttachments,
}) => {
  return (
    <Card style={{ width: '100%' }}>
      <AdvertForm
        advert={advertModel}
        onTitleChange={onTitleChange}
        onDescriptionChange={onDescriptionChange}
        onUpload={onUploadFile}
        isSubmiting={isSubmitting}
        isLoading={isLoading}
        onSubmit={() => {}}
        buttonText=""
        onRemoveFile={onRemoveAttachment}
        onReorderFiles={onReorderAttachments}
      />
    </Card>
  );
};

export default ContentStep;